module.exports = __webpack_public_path__ + "static/media/cancel.d1f9fae2.svg";